/*******************************************************************************
 * Copyright (c) Copyright (c) 2025 Bula Technologies
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 1.0.0
 *
 *******************************************************************************/


import { Grid } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { makeStyles } from 'tss-react/mui';
import SideBar from './SideBar';
import { MobileView } from 'react-device-detect';

import UserAvatar from "../../components/shared/Buttons/UserAvatar";
import { useSelector } from 'react-redux';


const PageHeader = () => {
  const { classes } = useStyles();
  const loginned = useSelector(state => state.user.loginned);
  const user = useSelector(state => state.user.user);

  return (
    <div className={classes.root}>

      <Grid container >

        <AppBar
          position="static"
          elevation={0}
          className={classes.appBar}
        >
          <Toolbar className={classes.toolbar}>
            <a
              href={"/dashboard"}
            >
              <img src="/assets/images/logo/logo.svg" height="50px" alt="" style={{ borderRadius: '10px' }} />
            </a>
           
            {loginned === true ?
              <UserAvatar user={user} /> : (

                <div className={classes.headerMenu}>

                  <MobileView>
                    <SideBar />
                  </MobileView>
                </div>)}
          </Toolbar>
        </AppBar>
      </Grid>
    </div>
  );
}

const useStyles = makeStyles({ "name": { PageHeader } })(theme => ({
  root: {
    position: "relative",
    background: theme.palette.background.paper,
  },
  user: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    color: "white",
    gap: "0px",
  },

  appBar: {
    width: '100%',
    background: theme.palette.background.paper,
  },
  toolbar: {
    flexWrap: 'wrap'
  },
  toolbarTitle: {
    color: 'white',
    flexGrow: 1
  },
  headerMenu: {
    marginLeft: "auto",
    display: "inline-block",
    textAlign: "right",
    marginTop: "10px",
    color: "white",
    "&:hover": {
      color: theme.palette.success.main
    }
  },
  linkBar: {
    marginLeft: "30px",
    textAlign: "right",
    marginRight: "30px",
    paddingTop: "30px"
  },
  header: {
    position: "absolute",
    left: "50%",
    display: "inline-block",
    transform: "translateX(-50%)",
    textAlign: "center",
    marginTop: "10px",
    color: "white",

  },
}));

export default PageHeader;

